import { type FC, useState } from 'react'
import classNames from 'classnames'

import { useZocksAuth } from '../../../components/ScopedBlock/hooks'
import { useGetOAuth2AppByClientIdQuery } from '../../../store/auth/auth'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'

interface ExternalCitationSourceIconProps {
  clientId?: string
  className: string
}

export const ExternalCitationSourceIcon: FC<ExternalCitationSourceIconProps> = ({ clientId, className }) => {
  const accountId = useAppSelector(selectAccountId)
  const { hasScope } = useZocksAuth()
  const [failedImageUrl, setFailedImageUrl] = useState<string | null>(null)

  const canReadApp = hasScope('**', 'oauth2_app:read', ['oauth2_app:admin'])
  const { data: app } = useGetOAuth2AppByClientIdQuery({ accountId, clientId: clientId ?? '' }, { skip: !clientId || !canReadApp })

  const imageUrl = app?.imageUrl && app.imageUrl !== failedImageUrl ? app.imageUrl : null

  return imageUrl ? (
    <div className={className}>
      <img src={imageUrl} alt={`${app?.name ?? 'App'} logo`} className='object-fit-contain' onError={() => setFailedImageUrl(imageUrl)} />
    </div>
  ) : (
    <div className={classNames(className, 'zocks-bg-color-gray-900')}>
      <i className='bi bi-plug lead-large zocks-text-white d-flex align-items-center justify-content-center' />
    </div>
  )
}
